define('Responsive/delegates/SwipeableViewDelegate',['require','exports','module','jquery-touch-fix/jquery-touch-fix','../vendor','../util/dom','../util/renderComplete','../helpers/SwipeableViewDelegateHelper'],function(require,exports,module){
    var $ = require( 'jquery-touch-fix/jquery-touch-fix' ),
        ReVendor = require( '../vendor' ),
        ReDom = require( '../util/dom' ),
        ReRenderComplete = require( '../util/renderComplete' ),
        SwipeableViewDelegateHelper = require( '../helpers/SwipeableViewDelegateHelper' );


    var SPACE = ' ',
        MathAbs=Math.abs,
        MathMin=Math.min,
        MathMax=Math.max,
        regex_coords=/[^(]*\(([^\)]+)\).*/,
        MIN_DUR=0.1,
        SCROLL_DUR=0.3,
        PERCENT100="100%",
        elementFilter = "object,video,iframe",
        events=$.extend({
            TOUCHABLE : "touchable",
            SCROLLTO  : "scrollPanel",
            RESIZE    : "scrollResize"
        },ReVendor.eventMap),
        ALL_EVENTS=[events.MOVE,events.END,events.CANCEL].join(SPACE);


    var _noop=function(){},
        _fn_true=function(){return true},
        _fn_false=function(){return false},
        _preventClick=function(e){
            e.preventDefault();
            $(this).off(e.type,_preventClick);
            return false;
        };



    var defaultOptions = {
            threshold : 0.5,
            swipeDistance : 0.7,
            swipeToSpeed  : 0.8,
            stayInBounds : true,
            watchers : {
                start       : _noop, 
                beforeChange: _noop, 
                cancel      : _fn_false,
                canSwipe    : _fn_true, 
                change      : _noop
            }
        };

    function TouchHandler(delegate){
        var handler=this;
        this.control=delegate.control;
        this.viewPort=PERCENT100;
        this.moving=false;
        this.thresholdExceeded = false;
        this.start=0;
        this.x=0;

        this.position={};
        this.options={};
        this.touchStartHandler = function(e){
            return handler.touchStart.call(handler,e);
        };
        this.touchMoveHandler = function(e){
            return handler.touchMove.call(handler,e);
        };
        this.touchEndHandler = function(e){
            return handler.touchEnd.call(handler,e);
        };
    }

    TouchHandler.prototype={
        bind        : function(){
            this.control.on(events.START,this.touchStartHandler);
            if(this.options.startView){
                this.control.animateSwipe({
                    coords   : [this.options.startView*(-this.control.getViewWidthPercent()),0,0]
                });
            }else{
                this.control.animateSwipe({
                    coords : this.control.lastPos
                });
            }
        },
        destroy     : function(){
            this.afterTouchEnd();
            this.control.off([events.RESIZE,events.SCROLLTO,events.MOVE].join(SPACE));
            this.control.touchable=false;
        },
        config      : function(opts){
            this.options=this.options||{};
            $.extend(true,this.options,defaultOptions,opts);
            this.watchers=this.options.watchers;
            this.context=this.context||this;
        },
        touchStart  : function(e){
            var canSwipe=this.watchers.canSwipe.call(this.context);
            if(this.moving || !canSwipe || $(this).is(elementFilter)){
                return true;
            }
            e.stopPropagation();
            //_end();
            var point = this.control.getPoint(e);

            this.startEvent=e;
            this.thresholdExceeded=false;
            this.minimum=this.control.getPercent(5);
            this.viewPort=this.control.getViewWidth();
            this.directionX=0;
            this.directionLocked=false;

            this.valid=this.watchers.start.call(this.context) || this.control.checkBounds(this.viewPort,this.options.stayInBounds);

            this.moved=false;
            $.extend(this.position,{
                startX : point.pageX,
                startY : point.pageY,
                pointX : point.pageX,
                pointY : point.pageY,
                stepsX : 0,
                stepsY : 0
            });

            this.start=this.x=(parseFloat(this.control.getTransformCoords()[0]));
            this.snapDistance=(this.control.getPercent(this.viewPort)) *this.options.threshold;

            this.control.one(events.END,this.touchEndHandler)
                .on(events.MOVE,this.touchMoveHandler);

            return true;
        },

        touchMove  : function(e){
            this.moving=true;

            var point  = this.control.getPoint(e),
                deltaX  = point.pageX - this.position.pointX,
                deltaY  = point.pageY - this.position.pointY,
                newX    = this.x + deltaX,
                dist    = MathAbs(point.pageX-this.position.startX),
                curDirectionX;

            this.position.pointX  = point.pageX;
            this.position.pointY  = point.pageY;
            this.position.stepsX += MathAbs(deltaX);// / viewPort;
            this.position.stepsY += MathAbs(deltaY);// / viewPort;
            
            if(!this.directionLocked){
                if ((this.position.stepsX < this.minimum) && (this.position.stepsY < this.minimum)) {
                    return true;
                }
                if ((this.position.stepsY >= this.position.stepsX) ){//|| ((stepsX-stepsY) < SWIPE)){
                    this.thresholdExceeded   = false;
                    this.moving=false;
                    this.position.stepsX  = 0;
                    return true;
                }
            }
            e.preventDefault();
            this.directionLocked = true;
            this.startEvent.preventDefault();
            e.stopPropagation();

            curDirectionX=deltaX > 0 ? 1 : deltaX < 0 ? -1 : this.directionX;

            if (!this.thresholdExceeded && dist >= this.snapDistance) {
                this.thresholdExceeded = true;
            } else if (this.thresholdExceeded && dist < this.snapDistance || (this.directionX!==curDirectionX)) {
                this.thresholdExceeded = false;
            }

            if(MathAbs(deltaX) > this.options.swipeDistance){
                this.thresholdExceeded   = true;
            }
            this.directionX  = curDirectionX;
            if(this.valid && !this.valid[-this.directionX]){
                deltaX=deltaX * this.control.easeOut((this.snapDistance - dist)/this.snapDistance);
                newX= this.x + deltaX;
            }

            this.x   = newX;
            this.control.animateSwipe({
                coords : [newX,0,0]
            });
            return true;
        },
        
        touchEnd    : function(e){
            var deltaX=this.start-this.x,
                dir=-1*this.directionX,
                change= this.thresholdExceeded   && 
                    (!this.valid || this.valid[dir])  && 
                    !this.watchers.cancel.call(this.context,dir),
                duration;

            if(deltaX !== 0 && (this.directionLocked || change)){
                e.preventDefault();
                e.stopPropagation();
                this.control.off('click',_preventClick).on('click',_preventClick);
            }
            
            if(deltaX===0){

                //startEvent.preventDefault();
                this.moving=false;
                this.directionLocked=false;
                this.afterTouchEnd();
                return true;
            }

            if(change){
                this.start+=this.control.getViewWidthPercent()*(-dir);
                this.watchers.beforeChange.call(this.context,dir)
            }

            duration= MathMax(MathMin(this.control.getPercent(MathAbs(this.start-this.x),this.control.getViewWidth())/10,1)*SCROLL_DUR,MIN_DUR);
            this.x=this.start;

            this.afterTouchEnd();
            var handler=this;
            this.control.animateSwipe({
                coords  : [this.x,0,0],
                duration: duration,
                callback : function(e){
                    if(change){
                        ReRenderComplete(function(){
                            handler.watchers.change.call(handler.context,dir);
                        });
                    }
                    handler.moving=false;
                    handler.directionLocked=false;
                }
            });
            
            return true;
        },
        afterTouchEnd :function(){
            this.control.off(ALL_EVENTS);
            return true;
        }

    }

    function SwipeableViewDelegate(config){
        var delegate=this;
        this.control=SwipeableViewDelegateHelper(this);
        this.touchHandler = new TouchHandler(this);
        this.config(config||{});
    }

    SwipeableViewDelegate.prototype = {
        config : function(opts){
            this.touchHandler.config(opts);
            return this;
        },

        create : function(view,context){
            this.control=SwipeableViewDelegateHelper(this,view);
            this.touchHandler.context=context;
            this.touchHandler.bind();
            return this;
        },

        destroy : function(){
            this.touchHandler.destroy();
            return this;
        },
        scrollTo  : function(to,from,cb){
            var dir,
                that=this;

            //Update the SNAPAT value
            // this.SNAPAT=viewPort*THRESHOLD;
            if(typeof from==='function'){
                cb=from;
                from=undefined;
            }
                // If recieving a dir, assume we want to move by a factor of 1
            if(from===undefined){
                to=to;
                from=0;
            } else {
                dir = -(from-(to*1));
            }
            this.touchHandler.canSwipe=this.touchHandler.watchers.canSwipe.call(this.touchHandler.context);

            this.touchHandler.watchers.beforeChange.call(this.touchHandler.context,dir);
            this.touchHandler.watchers.change.call(this.touchHandler.context,dir);
            this.touchHandler.start=this.touchHandler.x= (-1*to) * this.control.getViewWidthPercent();

            this.control.animateSwipeToTarget({
                coords      : [ this.touchHandler.x, 0, 0 ],
                duration    : this.touchHandler.canSwipe ? this.touchHandler.options.swipeToSpeed : 0,
                callback    : function(){
                    if(cb){
                        cb.call(that.touchHandler.context);
                    }
                }
            });
           return this; 
        }

    }

    return SwipeableViewDelegate;
});
